import React from 'react';
import { RootNavigator } from './navigation/RootNavigator';
import { AuthenticatedUserProvider } from './providers';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { registerLicense, L10n, setCulture } from '@syncfusion/ej2-base';

const queryClient = new QueryClient();

// Register Syncfusion license from Vite environment variable
const syncfusionKey = import.meta.env.VITE_SYNCFUSION_LICENSE_KEY;
if (syncfusionKey) {
  registerLicense(syncfusionKey);
} else {
  console.warn('Syncfusion license key not found in environment variables');
}

// Configure Syncfusion locale
setCulture('es-MX');
L10n.load({
  'es-MX': {
    'grid': {
      'ConfirmDelete': '¿Estas seguro de que deseas eliminar el registro?',
      'date': 'Date de commande'
    }
  }
});

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthenticatedUserProvider>
        <RootNavigator />
      </AuthenticatedUserProvider>
    </QueryClientProvider>
  );
}
